import BarChartComponent from "../../../Components/Home/BarChartComponent";
import GaugeChartComponent from "../../../Components/Home/GaugeChartComponent";
import RecommendationLinesComponent from "../../../Components/Home/RecommendationLinesComponent";
import Loader from "../../../Components/Shared/Loader";
import useLoading from "../../../Hooks/useLoading";
import { useContext, useEffect, useState } from "react";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { GetValuesToGaugeAPI, GetAllLinesAssignedAPI, GetProjectsWithBudgetAPI, GetAllProjectsYearsAPI, GetAllAnalysisYearsAPI } from "../../../API/HomeAPI";
import { HomeGrantsModel } from "../../../Models/HomeGrantsModel";
import { CompanyContext } from "../../../Contexts/CompanyContext";
import { HomeGaugesModel } from "../../../Models/HomeGaugesModel";
import { ProjectModel } from "../../../Models/ProjectModel";
import { SortDesc } from "../../../Utils/SortYear";
import { Carousel } from "antd";
import { useToast } from "../../hooks/toast";

const contentStyle: React.CSSProperties = {
    margin: 0,
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
};

export default function Home () {
    const { loading, toggleLoading } = useLoading();
    const { company } = useContext(CompanyContext);
    const [ grantsHome, setGrantsHome ] = useState<HomeGrantsModel[]>([]);
    const [ projects, setProjects ] = useState<ProjectModel[]>([]);
    const [ gaugeValues, setGaugeValues ] = useState<HomeGaugesModel>({ projectSum: 0, potentialValue: 0, financialValue: 0 } as HomeGaugesModel);
    const [ yearsAnalysis, setYearsAnalysis ] = useState<number[]>([]);
    const [ yearsProjects, setYearsProjects ] = useState<number[]>([]);
    const [ yearAnalysisSelected, setYearAnalysisSelected ] = useState<number>();
    const [ yearProjectsSelected, setYearProjectsSelected ] = useState<number>();

    const toast = useToast();

    const getAllLinesToHome = async () => {
        try {
            toggleLoading(true);

            await GetAllLinesAssignedAPI(company.id, yearProjectsSelected).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setGrantsHome(resp.data);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getAllValuesToGauge = async () => {
        try {
            toggleLoading(true);

            await GetValuesToGaugeAPI(company.id, yearProjectsSelected, yearAnalysisSelected).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setGaugeValues(resp.data);
                }
            }).finally(() => toggleLoading(false));

        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getProjectsToBarChart = async () => {
        try {
            toggleLoading(true);

            await GetProjectsWithBudgetAPI(company.id, yearProjectsSelected).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setProjects(resp.data);
                }
            }).finally(() => toggleLoading(false));

        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getAllNews = async () => {
        try {
            toggleLoading(true);
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getAllYears = async () => {
        try {
            toggleLoading(true);

            await GetAllProjectsYearsAPI(company.id).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setYearsProjects(resp.data);
                }
            });

        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }
    const getAllAnalysisYears = async () => {
        try {
            toggleLoading(true);

            await GetAllAnalysisYearsAPI(company.id).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setYearsAnalysis(resp.data);
                }
            });

        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    useEffect(() => {
        if (company.id !== undefined) {
            getAllYears();
            getAllAnalysisYears();
            getAllLinesToHome();
            getAllValuesToGauge();
            getProjectsToBarChart();
            getAllNews();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ company ]);

    useEffect(() => {
        if (yearProjectsSelected) {
            getAllLinesToHome();
            getProjectsToBarChart();
            getAllValuesToGauge();
        } else if (yearAnalysisSelected) {
            getAllValuesToGauge();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ yearProjectsSelected, yearAnalysisSelected ]);

    return (
        <div>
            {loading && <Loader />}
            <RecommendationLinesComponent grantsHome={grantsHome} companyId={company.id} />
            <div style={{ display: 'flex', width: '100%', height: '30rem', margin: '25px 0px', justifyContent: 'space-between' }}>
                <GaugeChartComponent
                    gaugeValues={gaugeValues}
                    yearsAnalysis={SortDesc(yearsAnalysis)}
                    yearsProjects={SortDesc(yearsProjects)}
                    yearAnalysisSelected={yearAnalysisSelected}
                    yearProjectsSelected={yearProjectsSelected}
                    setYearAnalysisSelected={setYearAnalysisSelected}
                    setYearProjectsSelected={setYearProjectsSelected}
                />
                <BarChartComponent projects={projects} companyId={company.id} />
            </div>
        </div>
    )
}